var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":"MainLayout"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }